/**
 * Três ações da conclusão. Só chama os callbacks que recebe: não navega,
 * não chama a API e não decide quais cartões entram na sessão.
 */
import type { ConclusaoAcoesProps } from "./conclusaoLeitura";
import { revisaoPrimaryActionClass } from "./revisaoSurfaces";

const SECUNDARIO_CLASS =
  "inline-flex min-h-[52px] w-full items-center justify-center gap-2 rounded-full border border-edge bg-surface px-6 text-sm font-medium text-ink hover:bg-surface-hover md:w-auto";

export function ConclusaoAcoes({
  antecipar,
  erros,
  onVoltar,
  onAntecipar,
  onRevisarErros,
}: ConclusaoAcoesProps): JSX.Element {
  return (
    <div className="flex w-full flex-col gap-2 md:flex-row md:flex-wrap">
      <button type="button" data-acao="voltar" onClick={onVoltar} className={SECUNDARIO_CLASS}>
        Voltar ao início
      </button>
      {antecipar > 0 ? (
        <button
          type="button"
          data-acao="antecipar"
          onClick={onAntecipar}
          className={SECUNDARIO_CLASS}
        >
          {`Antecipar amanhã (${antecipar})`}
        </button>
      ) : null}
      {erros.length > 0 ? (
        <button
          type="button"
          data-acao="erros"
          onClick={onRevisarErros}
          className={`${revisaoPrimaryActionClass} w-full md:w-auto`}
        >
          {erros.length === 1 ? "Revisar o erro" : `Revisar os ${erros.length} erros`}
        </button>
      ) : null}
    </div>
  );
}
